import React, { useState, createContext, ReactNode } from "react";
import SnackBarAlert from "./alert";

interface AlertContextProviderProps {
  alertInfo: SimpleInfoProps | undefined;
  setAlertInfo: (info: SimpleInfoProps | undefined) => void;
  successInfo: SimpleInfoProps | undefined;
  setSuccessInfo: (info: SimpleInfoProps | undefined) => void;
  dialogInfo: SimpleDialogProps | undefined;
  setDialogInfo: (info: SimpleDialogProps | undefined) => void;
  loadingBackdrop: boolean;
  setLoadingBackdrop: (show: boolean) => void;
}

interface SimpleInfoProps {
  open: boolean;
  message: string;
}

interface SimpleDialogProps {
  open: boolean;
  title: string;
  content: string;
  onOk: () => void;
}

// Create Context Object
export const AlertContext = createContext<AlertContextProviderProps>(
  {} as AlertContextProviderProps
);

// Define props for the provider, including children
interface AlertProviderProps {
  children: ReactNode;
}

export const AlertContextProvider = ({ children }: AlertProviderProps) => {
  const [alertInfo, setAlertInfo] = useState<SimpleInfoProps | undefined>();
  const [successInfo, setSuccessInfo] = useState<SimpleInfoProps | undefined>();
  const [dialogInfo, setDialogInfo] = useState<SimpleDialogProps | undefined>();
  const [loadingBackdrop, setLoadingBackdrop] = useState<boolean>(false);

  return (
    <AlertContext.Provider
      value={{
        alertInfo,
        setAlertInfo,
        successInfo,
        setSuccessInfo,
        dialogInfo,
        setDialogInfo,
        loadingBackdrop,
        setLoadingBackdrop
      }}
    >
      <SnackBarAlert />
      {children}
    </AlertContext.Provider>
  );
};
